const cardData = [
  {
    id: 1,
    image: "images/Products/m2.jpg",
    title: "Men",
    price: "45$",
    category: "Men",
  },
  {
    id: 2,
    image: "images/Products/m1.jpg",
    title: "Men",
    price: "35$",
    category: "Men",
  },
  {
    id: 3,
    image: "images/Products/m3.jpg",
    title: "Men",
    price: "75$",
    category: "Men",
  },
  {
    id: 4,
    image: "images/Products/m4.jpg",
    title: "Men",
    price: "55$",
    category: "Men",
  },
  // {
  //   id: 5,
  //   image: "images/Products/1.jpg",
  //   title: "Men",
  //   price: "60$",
  //   category: "Men",
  // },
  // {
  //   id: 6,
  //   image: "images/Products/3.jpg",
  //   title: "Men",
  //   price: "75$",
  //   category: "Men",
  // },
  // {
  //   id: 7,
  //   image: "images/Products/6.jpg",
  //   title: "Men",
  //   price: "35$",
  //   category: "Men",
  // },
  // {
  //   id: 8,
  //   image: "images/Products/7.jpg",
  //   title: "Men",
  //   price: "50$",
  //   category: "Men",
  // },
  // {
  //   id: 9,
  //   image: "images/Products/p1.jpg",
  //   title: "Woman",
  //   price: "85$",
  //   category: "Woman",
  // },

  {
    id: 10,
    image: "images/Products/p2.png",
    title: "Woman",
    price: "35$",
    category: "Woman",
  },
  {
    id: 11,
    image: "images/Products/p3.png",
    title: "Woman",
    price: "25$",
    category: "Woman",
  },
  // {
  //   id: 12,
  //   image: "images/Products/p4.png",
  //   title: "Woman",
  //   price: "95$",
  //   category: "Woman",
  // },
  // {
  //   id: 13,
  //   image: "images/Products/w2.webp",
  //   title: "Watches",
  //   price: "250$",
  //   category: "Watches",
  // },
  // {
  //   id: 14,
  //   image: "images/Products/w3.webp",
  //   title: "Watches",
  //   price: "400$",
  //   category: "Watches",
  // },
  // {
  //   id: 15,
  //   image: "images/Products/10.jpg",
  //   title: "Watches",
  //   price: "520$",
  //   category: "Watches",
  // },
  {
    id: 16,
    image: "images/Products/w4.webp",
    title: "Watches",
    price: "450$",
    category: "Watches",
  },
  // {
  //   id: 17,
  //   image: "images/Products/s1.jpeg",
  //   title: "Shoes",
  //   price: "90$",
  //   category: "Shoes",
  // },
  // {
  //   id: 18,
  //   image: "images/Products/s2.jpeg",
  //   title: "Shoes",
  //   price: "80$",
  //   category: "Shoes",
  // },
  // {
  //   id: 19,
  //   image: "images/Products/s6.png",
  //   title: "Shoes",
  //   price: "70$",
  //   category: "Shoes",
  // },
  {
    id: 20,
    image: "images/Products/s7.jpeg",
    title: "Shoes",
    price: "60$",
    category: "Shoes",
  },
];

export default cardData;
